(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    /* ===== Open Upcart drawer after Add to Cart from product cards ===== */
  (function () {
    if (window.__cardAtcUpcartInit) return;
    window.__cardAtcUpcartInit = true;

    function hasUpcart() {
      return typeof window.upcartOpenCart === 'function' ||
             typeof window.upcartRefreshCart === 'function' ||
             !!document.getElementById('upCart');
    }

    function isUpcartOpen() {
      var host = document.getElementById('upCart');
      var root = (host && host.shadowRoot) ? host.shadowRoot : document;
      return !!root.querySelector('#CartPopup[class*="active"], #UpcartPopupBackDrop[class*="active"]');
    }

    function upcartRefreshAndOpen() {
      /* refresh is fire-and-forget; open is independent (do not wait on refresh) */
      try {
        if (typeof window.upcartRefreshCart === 'function') {
          var p = window.upcartRefreshCart();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        }
      } catch (err) {
        console.warn('Card ATC: upcartRefreshCart failed', err);
      }

      var tries = 0;
      (function tryOpen() {
        tries++;
        if (isUpcartOpen()) return;

        if (typeof window.upcartOpenCart === 'function') {
          try { window.upcartOpenCart(); } catch (err) { console.warn('Card ATC: upcartOpenCart failed', err); }
        }

        if (tries < 4) {
          setTimeout(tryOpen, 450);
        } else if (typeof window.upcartOpenCart !== 'function' && !isUpcartOpen()) {
          /* last resort: Upcart usually opens on cart icon click */
          var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
          if (icon) icon.click();
        }
      })();
    }

    /* Cards: image overlay button (simple products) + quick add modal (variant products) */
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var btn = target.closest(
        '.card__quick-add-overlay product-form button[type="submit"], quick-add-modal product-form button[type="submit"]'
      );
      if (!btn || btn.disabled || !hasUpcart()) return;

      setTimeout(function () {
        if (!isUpcartOpen()) { upcartRefreshAndOpen(); }
      }, 1200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
